const PREFIX = "CI";

export interface MasterPolicyQuery {
  agentCode: string;
  productCode: string;
}

export interface CIUploadStatusPayload {
  uploadStatus: boolean;
  uploadErrorMsg: string | null;
}

export interface CISelectedPolicyParams {
  cngeNote: {
    productType: string;
    productCode: string;
    productName: string;
    mkagAgent: Record<string, unknown>;
    effectiveDate: string;
    expiryDate: string;
    cnoteDate: string;
    masterPolicyNo: string;
  };
  operator: string;
}

export interface CITemplatePayload {
  fileName: string;
  productType: string;
}

export class GET_CI_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET CI AGENT LIST`;
  constructor(public readonly payload: string) {}
}

export class GET_CI_PRODUCT_LIST {
  public static readonly type = `[${PREFIX}] GET CI PRODUCT LIST`;
  constructor(public readonly payload: string) {}
}

export class GET_MASTER_POLICY_LIST {
  public static readonly type = `[${PREFIX}] GET MASTER POLICY LIST`;
  constructor(public readonly payload: MasterPolicyQuery) {}
}

export class UPLOAD_CI_TEMPLATE {
  public static readonly type = `[${PREFIX}  UPLOADING CI XLS TEMPLATE`;
  constructor(public readonly payload: { raw: File | null }) {}
}

export class UPDATE_UPLOAD_CI_STATUS {
  public static readonly type = `[${PREFIX}  UPLOADING CI STATUS XLS TEMPLATE`;
  constructor(public readonly payload: CIUploadStatusPayload | null) {}
}

export class UPDATE_SELECTED_POLICY {
  public static readonly type = `[${PREFIX}  UPDATE SELECTED MASTER POLICY`;
  constructor(public readonly payload: string | CISelectedPolicyParams) {}
}

export class GET_CI_TEMPLATE {
  public static readonly type = `[${PREFIX} GET CI TEMPLATE`;
  constructor(public readonly payload: CITemplatePayload) {}
}

export class GET_CI_REPORT {
  public static readonly type = `[${PREFIX} GET CI REPORT`;
  constructor(public readonly payload: unknown) {}
}
